function getValueAtPath(object: any, path: string, defaultValue?: any) {
  return (
    path
      .replace(/\[/g, '.')
      .replace(/\]/g, '')
      .split('.')
      .reduce((o, k) => o?.[k], object) || defaultValue
  )
}

export default getValueAtPath
